<template>
  <div :id="componentId" class="sp6-news-section" :style="{ backgroundColor: bgColor }">
    <div class="sp6-block_9 flex-col">
      <div
        v-for="(row, rowIndex) in rows"
        :key="rowIndex"
        class="sp6-group_3 flex-row justify-between"
      >
        <div
          v-for="(item, colIndex) in row"
          :key="item.articleCode || `${rowIndex}-${colIndex}`"
          class="sp6-box_6 flex-row"
        >
          <img
            class="sp6-image_4"
            referrerpolicy="no-referrer"
            :src="item.imageUrl"
            @click="goTo(item.url)"
          />
          <div class="sp6-box_7 flex-col justify-between">
            <span class="sp6-text_26" @click="goTo(item.url)">{{ item.title }}</span>
            <div class="sp6-box_8 flex-row">
              <span class="sp6-text_27">{{ item.source }}</span>
              <span class="sp6-text_28">&nbsp;|&nbsp;{{ formatTime(item.publishTime) }}</span>
              <div class="sp6-image-text_1 flex-row justify-between">
                <ShareButton :news-code="item.newsCode" :title="item.title" />
              </div>
              <div class="sp6-image-text_2 flex-row justify-between">
                <FavoriteButton :news-code="item.articleCode" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FavoriteButton from '../../../channel/components/FavoriteButton.vue'
import ShareButton from '../../../channel/components/ShareButton.vue'

export default {
  name: 'NewsSection',
  components: {
    FavoriteButton,
    ShareButton
  },
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_3'
    }
  },
  data() {
    return {
      bgColor: 'rgba(230, 236, 247, 1)',
      list: [
        {
          articleCode: '1',
          newsCode: '19299351',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
          url: ''
        },
        {
          articleCode: '2',
          newsCode: '19299352',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
          url: ''
        },
        {
          articleCode: '3',
          newsCode: '19299353',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
          url: ''
        },
        {
          articleCode: '4',
          newsCode: '19299354',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
          url: ''
        },
        {
          articleCode: '5',
          newsCode: '19299355',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
          url: ''
        },
        {
          articleCode: '6',
          newsCode: '19299356',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'),
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          source: '中国品牌',
          publishTime: '2026-07-09 00:00:00',
          url: ''
        }
      ]
    };
  },
  computed: {
    rows() {
      const rows = [];
      for (let i = 0; i < this.list.length; i += 2) {
        rows.push(this.list.slice(i, i + 2));
      }
      return rows;
    }
  },
  methods: {
    formatTime(publishTime) {
      if (!publishTime) return '';
      const now = Date.now();
      let parseValue = publishTime;
      if (typeof publishTime === 'string' && publishTime.indexOf(' ') > -1 && publishTime.indexOf('T') === -1) {
        parseValue = publishTime.replace(' ', 'T');
      }
      const time = new Date(parseValue).getTime();
      if (isNaN(time)) return publishTime;
      const diffMinutes = Math.floor((now - time) / 1000 / 60);
      if (diffMinutes < 1) return '刚刚';
      if (diffMinutes < 60) return `${diffMinutes}分钟前`;
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours < 24) return `${diffHours}小时前`;
      const diffDays = Math.floor(diffHours / 24);
      return `${diffDays}天前`;
    },
    goTo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>
<style scoped>
.sp6-news-section {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
}

.sp6-news-section .sp6-block_9 {
  position: relative;
  width: 1400px;
  height: auto !important;
  margin: 0 auto;
  background: none !important;
}

.sp6-news-section .sp6-group_3 {
  width: 1400px !important;
  height: auto !important;
  margin: 20px 0 !important;
}

.sp6-news-section .sp6-group_3:last-child {
  margin-bottom: 0 !important;
}

.sp6-news-section .sp6-box_6 {
  width: 683px !important;
  height: auto !important;
  background-color: rgba(245, 245, 247, 1);
}

.sp6-news-section .sp6-image_4 {
  width: 317px;
  height: 177px;
  object-fit: cover;
  cursor: pointer;
}

.sp6-news-section .sp6-box_7 {
  width: 326px !important;
  height: auto !important;
  margin: 23px 15px 23px 25px !important;
}

.sp6-news-section .sp6-text_26 {
  width: 326px !important;
  height: auto !important;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  text-align: left;
  line-height: 1.4;
  cursor: pointer;
}

.sp6-news-section .sp6-box_8 {
  width: 326px !important;
  height: auto !important;
  margin-top: 16px !important;
  align-items: center;
}

.sp6-news-section .sp6-text_27 {
  width: auto !important;
  height: auto !important;
  line-height: 18px;
  align-self: center;
  display: flex;
  align-items: center;
  margin-top: 0 !important;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
}

.sp6-news-section .sp6-text_28 {
  width: auto !important;
  height: auto !important;
  white-space: nowrap;
  line-height: 18px;
  align-self: center;
  display: flex;
  align-items: center;
  margin-top: 0 !important;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
}

.sp6-news-section .sp6-image-text_1,
.sp6-news-section .sp6-image-text_2 {
  align-self: center;
  align-items: center;
  margin-top: 0 !important;
}

.sp6-news-section .sp6-image-text_1 {
  margin: 0 0 0 auto !important;
}

.sp6-news-section .sp6-image-text_2 {
  margin: 0 0 0 16px !important;
}

.sp6-news-section .sp6-thumbnail_4,
.sp6-news-section .sp6-thumbnail_5 {
  margin-top: 0 !important;
}
</style>